// removed by extract-text-webpack-plugin
module.exports = {"header":"MobileHeader-module__header____vEpO","body":"MobileHeader-module__body___rzZgv","logo":"MobileHeader-module__logo___yhD7a","menu":"MobileHeader-module__menu___11jsJ","menu-item":"MobileHeader-module__menu-item___3G3JP"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/Header/MobileHeader.module.scss
// module id = 243
// module chunks = 0 1